export default __webpack_public_path__ + "static/media/grafema_ciceco_11.920056bb.jpg";